import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import { Icon, Typography } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { UserContext } from "../App";
import { useContext } from "react";
export default function BasicMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const user = useContext(UserContext);

  console.log(user);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEmoji = (event) => {
    props.changeStudentEmojiTag(event.target.innerText, props.studentID); //change emoji list
  };

  const [tooltipOpen, setTooltipOpen] = React.useState(
    (props.showTooltip ? true : false) && !props.tooltipPrevSet, //make sure that showTooltip is true (index is 0) and that the tooltip hasn't been seen before
  );

  const handleTooltipClose = () => {
    setTooltipOpen(false);
    if (!props.tooltipPrevSet && typeof props.setTooltipStatus === "function") {
      props.setTooltipStatus(); //set that the tooltip has been seen
    }
  };

  const shouldShowEmoji = (emoji, className) => {
    console.log(props.gender);
    console.log(emoji.length);
    if (user["email"] != "mdickler@bialik.ca" && emoji.length > 2) return false;
    if (props.gender == "Male" && emoji.includes("Girls")) return false;
    if (props.gender == "Female" && emoji.includes("Boys")) return false;
    if (emoji.length <= 2) return true;
    if (className.includes("V") && emoji.startsWith("V")) return true;
    if (className.includes("H") && emoji.startsWith("H")) return true;
    if (emoji.startsWith("T")) return true;

    return false;
  };

  return (
    <div className="smallMenu">
      <Tooltip
        arrow
        open={tooltipOpen}
        onClose={handleTooltipClose}
        onOpen={handleTooltipClose}
        title={`Click the three dots to add a custom tag to ${props.studentName}`}
        placement="right"
      >
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? "long-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          disableRipple
          disableTouchRipple
          sx={{
            backgroundColor: "transparent",
            "&:hover": {
              backgroundColor: "transparent",
            },
            "&.Mui-selected": {
              backgroundColor: "transparent",
            },
            "&.Mui-selected:hover": {
              backgroundColor: "transparent",
            },
            flexDirection: "column",
          }}
        >
          <Typography
            variant="caption"
            sx={{ width: "100%", textAlign: "left", marginLeft: "12px" }}
          >
            Add Emoji Tag to {props.studentName}
          </Typography>
          <div>
            {[
              "🔴",
              "🟠",
              "🟡",
              "🟢",
              "🔵",
              "🟣",
              "🍎",
              "✏️",
              "🔔",
              "📚",
              "📎",
              "🧩",
              "⚠️",
              "🎭",
              "🥇",
              "🥈",
              "🥉",
              "🚩",
              "H Cross Country",
              "H Gr3 House Leagues",
              "H Gr4-5 House Leagues",
              "H Jr Boys Basketball",
              "H Jr Boys Soccer",
              "H Jr Boys Softball",
              "H Jr Coed Ice Hockey",
              "H Jr Girls Basketball",
              "H Jr Girls Soccer",
              "H Jr Girls Softball",
              "H Sr Boys Basketball",
              "H Sr Boys Flag Football",
              "H Sr Boys Soccer",
              "H Sr Boys Softball",
              "H Sr Boys Ultimate Frisbee",
              "H Sr Boys Volleyball",
              "H Sr Coed Ice Hockey",
              "H Sr Girls Basketball",
              "H Sr Girls Floor Hockey",
              "H Sr Girls Soccer",
              "H Sr Girls Softball",
              "H Sr Girls Ultimate Frisbee",
              "H Sr Girls Volleyball",
              "H Track & Field",

              "V Cross Country",
              "V Gr3-5 House Leagues",
              "V Jr Boys Basketball",
              "V Jr Boys Soccer",
              "V Jr Boys Softball",
              "V Jr Co-ed Hockey",
              "V Jr Girls Basketball",
              "V Jr Girls Soccer",
              "V Jr Girls Softball",
              "V Sr Boys Basketball",
              "V Sr Boys Flag Football",
              "V Sr Boys Soccer",
              "V Sr Boys Softball",
              "V Sr Boys Ultimate Frisbee",
              "V Sr Boys Volleyball",
              "V Sr Co-ed Hockey",
              "V Sr Girls Basketball",
              "V Sr Girls Floor Hockey",
              "V Sr Girls Soccer",
              "V Sr Girls Softball",
              "V Sr Girls Ultimate Frisbee",
              "V Sr Girls Volleyball",
              "V Track & Field",
              "T-Shirt Size",
            ].map(
              (emoji, index) =>
                shouldShowEmoji(emoji, props.class) && (
                  <>
                    {index !== 0 && index % 6 == 0 && index < 18 && <br />}
                    {emoji.length > 2 && <br />}
                    <IconButton
                      key={emoji + index}
                      onClick={handleEmoji}
                      sx={
                        (props.customEmojiTag[props.studentID] &&
                          props.customEmojiTag[props.studentID].includes(
                            emoji,
                          ) && {
                            border: "2px dotted green",
                            margin: "1px",
                            borderRadius: emoji.length > 2 ? "8px" : "50%",
                          }) || { margin: "1px" }
                      }
                      size={"small"}
                    >
                      {emoji.length > 2 ? (
                        <Typography variant="body2">{emoji}</Typography>
                      ) : (
                        emoji
                      )}
                    </IconButton>
                  </>
                ),
            )}
          </div>
        </MenuItem>
        <MenuItem
          onClick={() => props.setHelpOpen([true, "opts", props.class])}
        >{`${props.class} Options`}</MenuItem>
        {props.parentEmails && (
          <MenuItem
            onClick={(event) => {
              navigator.clipboard.writeText(props.parentEmails);
              let button = event.currentTarget;
              button.innerHTML = "Copied!";

              setTimeout(() => {
                button.innerHTML = "Copy Parent Emails";
              }, 1000);
            }}
          >
            Copy Parent Emails
          </MenuItem>
        )}
        {props.studentEmail && (
          <MenuItem
            onClick={(event) => {
              navigator.clipboard.writeText(props.studentEmail);
              let button = event.currentTarget;
              button.innerHTML = "Copied!";

              setTimeout(() => {
                button.innerHTML = "Copy Student Email";
              }, 1000);
            }}
          >
            Copy Student Email
          </MenuItem>
        )}
        <MenuItem
          onClick={(event) => {
            navigator.clipboard.writeText(props.studentID);
            let button = event.currentTarget;
            button.innerHTML = "Copied!";

            setTimeout(() => {
              button.innerHTML = "Copy Student ID";
            }, 1000);
          }}
        >
          Copy Student ID
        </MenuItem>
      </Menu>
    </div>
  );
}
